import { PremiumsPaymentSchedule } from '@app/domain/model/eshop/transport/PremiumsPaymentSchedule';

export function buildHomePaymentSchedule(
    paymentSchedule: PremiumsPaymentSchedule[],
    ridersSum: number,
): PremiumsPaymentSchedule[] {
    if (paymentSchedule.length === 0) return [];

    if (ridersSum <= 0) return paymentSchedule;

    const scheduleWithRiders = [...paymentSchedule];

    scheduleWithRiders[0] = {
        ...scheduleWithRiders[0],
        amount: scheduleWithRiders[0].amount + ridersSum,
        amountAfterDiscount: scheduleWithRiders[0].amountAfterDiscount + ridersSum,
    };

    return scheduleWithRiders;
}
